'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var key = require('interface-datastore/key');

var fromString = require('uint8arrays/from-string');

var apiFile = new key.Key('api');

function apiAddr(store) {
  return {
    get: function get() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var value;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return store.get(apiFile);

              case 2:
                value = _context.sent;
                return _context.abrupt("return", value && value.toString());

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    set: function set(value) {
      return store.put(apiFile, fromString.fromString(value.toString()));
    },
    delete: function _delete() {
      return store.delete(apiFile);
    }
  };
}

exports.apiAddr = apiAddr;